import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class AppDeveloperProfileShareVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareCreateany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareReadany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareRead,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareDelete,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareUpdate,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareCreateany,
        PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareUpdateany,
        PermissionAttributesEnum.GlobalOperationAppdeveloperprofileshareDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareCreate,
        PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareUpdate,
        PermissionAttributesEnum.ContextClientOperationAppdeveloperprofileshareDelete,
      ],
    });
  };
}
